import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TableWrapper: {
    position: 'relative'
  },
  ApplyFilterWrapper: {
    marginTop: theme.spacing(4),
    textAlign: 'right'
  },
  ActivateButton: {
    padding: theme.spacing(0)
  },
  PromocodeCustomMenu: {
    '& a, & button': {
      padding: theme.spacing(0.75, 1),
      width: '100%',
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(16),
      justifyContent: 'flex-start'
    }
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active': {
      boxShadow: theme.customShadows.widgetWide
    }
  },
  FilterChip: {
    display: 'flex',
    '& span': {
      marginLeft: theme.spacing(1)
    }
  },
  filterWrapper: {
    padding: theme.spacing(2),
    minWidth: 300
  },
  autocompleteWrapper: {
    position: 'relative',
    width: '100%'
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 1000,
    maxHeight: 200,
    overflow: 'auto',
    marginTop: theme.spacing(0.5),
    boxShadow: theme.shadows[3]
  },
  noResultsText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    textAlign: 'center'
  },
  menuItem: {
    padding: theme.spacing(1.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  itemName: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.text.primary
  },
  itemDetail: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  activeChip: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText
  },
  inactiveChip: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white
  },
  buttonsContainer: {
    gap: `${theme.spacing(1)}px`
  }
}))

